var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoreFloor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 158,
    viewBox: "0 0 169 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 108.3V44.9l85.8 48.9L169 44.9v63.4l-83.2 48.9L0 108.3z",
    fill: "#FFA621"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 108.3V44.9l85.8 48.9v63.4L0 108.3z",
    fill: "#ED8E00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5 0 0 44.9l85.8 50.2L169 44.9 84.5 0z",
    fill: "#FFC774"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M103 124.1v-13.2l10.6-5.3v13.2l-10.6 5.3zM68.7 124.1v-13.2l-10.6-5.3v13.2l10.6 5.3zM118.8 113.5v-13.2l10.6-5.3v13.2l-10.6 5.3zM52.8 113.5v-13.2L42.2 95v13.2l10.6 5.3zM134.7 103V89.8l10.6-5.3v13.2l-10.6 5.3zM37 103V89.8l-10.6-5.3v13.2L37 103zM150.5 92.4V79.2l10.6-5.3v13.2l-10.6 5.3zM21.1 92.4V79.2l-10.6-5.3v13.2l10.6 5.3z",
    fill: "#FFE3BA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7 25c9.7 0 17.5 7.8 17.5 17.5S93.4 60 83.7 60s-17.5-7.8-17.5-17.5S74.1 25 83.7 25z",
    fill: "#FFDAA2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1 37.9v3.8h3.6v1.7h-3.6v3.8h-1.9v-3.8h-3.6v-1.7h3.6v-3.8h1.9zM81.5 37.3h-1.2c-2.8.2-4.1 1.7-4.5 3.3h.1c.7-.7 1.6-1.1 2.9-1.1 2.3 0 4.2 1.6 4.2 4.5 0 2.7-2.1 4.9-5 4.9-3.7 0-5.4-2.7-5.4-6 0-2.6.9-4.7 2.4-6.1 1.3-1.2 3.1-1.9 5.2-2 .6-.1 1 0 1.3 0v2.5zm-1.8 6.8c0-1.3-.7-2.4-2-2.4-.9 0-1.6.5-1.9 1.2-.1.2-.1.4-.1.8.1 1.4.8 2.8 2.2 2.8 1.1 0 1.8-1 1.8-2.4z",
    fill: "#FFFFFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreFloor);
export default __webpack_public_path__ + "static/media/more_floor.b65e31eda9d1d35e5cbf37ea2694d24a.svg";
export { ForwardRef as ReactComponent };